import React from 'react';
import { getInitials } from '../../../utils';
import ImageWithLoading from '../ImageWithLoading/ImageWithLoading';
import styles from './AvatarCircle.module.css';

interface AvatarCircleProps {
  name: string;
  photoUrl?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const AvatarCircle: React.FC<AvatarCircleProps> = ({ name, photoUrl, size = 'md', className = '' }) => (
  <div className={`${styles.avatar} ${styles[size]} ${className}`.trim()}>
    {photoUrl ? (
      <img src={photoUrl} alt={name} className={styles.photo} />
    ) : (
      getInitials(name)
    )}
  </div>
);

export default AvatarCircle;
